import {baseURL} from './config';
require('es6-promise').polyfill();
require('isomorphic-fetch');

const makeRequest = (method, apiRoute, body) => {
  const fullUrl = `${baseURL}/${apiRoute}`;
  const commonOpts = {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
  };

  const opts = body ?
    Object.assign(commonOpts, { body: JSON.stringify(body) }) :
    commonOpts;

  return fetch(fullUrl, opts)
    .then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        const { status } = response;
        const error = {json, status};
        return Promise.reject(error);
      }

      return json;
    });

  // let requestParams = body ? {
  //   type: method,
  //   url: `${baseURL}/${apiRoute}`,
  //   data: JSON.stringify(body),
  //   contentType: "application/json",
  //   datatype: "json",
  //   error: (error) => Promise.reject(error)
  // } : {
  //   type: method,
  //   url: `${baseURL}/${apiRoute}`,
  //   error: (err)=>{
  //     console.log(err.responseText);
  //   }
  // };
  // return $.ajax(requestParams)
  //   .then(res =>res);
};

export const post = (apiRoute, body) => makeRequest('POST', apiRoute, body);
export const get = (apiRoute) => makeRequest('GET', apiRoute);



// WEBPACK FOOTER //
// ./src/libs/apiMethods.js